import { IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IAccount } from "@gtmhub/core";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";
import { ISubscriptionConverted } from "@gtmhub/login/models";

export class TrialInfoCtrl {
  secondsLeft: number;
  percentageTimeLeft: number;
  timeLeft: string;
  account: IAccount;
  isAccountTrial: boolean;
  accountTypes: {
    trial: number;
    client: number;
    internal: number;
  };

  private isAccountConverted: boolean;

  public static $inject = ["$scope", "AccountResolverService", "$state"];

  constructor(private $scope: IScope, private accountResolverService: AccountResolverService, private $state: StateService) {
    this.accountTypes = {
      trial: 0,
      client: 1,
      internal: 2,
    };

    this.account = this.accountResolverService.getAccountData();

    if (this.account.subscriptions.length) {
      this.isAccountConverted = this.account.subscriptions.find((license) => license.type === "regular").isConverted;
    }

    this.isAccountTrial = this.account.type === this.accountTypes.trial && !this.isAccountConverted;

    this.checkExpiration();

    this.$scope.$on("subscriptionConverted", (evt, subscriptionConverted: ISubscriptionConverted) => this.subscriptionConverted(subscriptionConverted));
  }

  goToBilling(): void {
    this.$state.go("gtmhub.editionPlanChange");
  }

  private checkExpiration(): void {
    const trialExpiration = this.accountResolverService.checkExpirationOfTrialAccount();
    this.secondsLeft = trialExpiration.secondsLeft;
    this.timeLeft = trialExpiration.timeLeft;
    this.percentageTimeLeft = trialExpiration.percentageTimeLeft;
  }

  private subscriptionConverted(subscriptionConverted: ISubscriptionConverted) {
    if (this.account.id === subscriptionConverted.accountId) {
      const subscriptionTypeRegular = subscriptionConverted.subscriptions.find((license) => license.type === "regular");
      this.isAccountTrial = !subscriptionTypeRegular.isConverted;
      this.$scope.$apply();
    }
  }
}
